
const LayoutItem = {
    PANORAMA_VIEWER:'Panellum',
    MODEL_VIEWER:'Autodesk.Viewer',
    PLAN_VIEWER:'PlanView',
}

const LayoutPlace = {
    TOP_LEFT:'Top left',
    TOP_RIGHT:'Top right',
    BOTTOM_LEFT:'Bottom left',
    BOTTOM_RIGHT:'Bottom right',
}


export {
    LayoutItem,
    LayoutPlace
};
